import { render, staticRenderFns } from "./FormP2.vue?vue&type=template&id=2bdd8cf5"
import script from "./FormP2.vue?vue&type=script&lang=ts"
export * from "./FormP2.vue?vue&type=script&lang=ts"
import style0 from "./FormP2.vue?vue&type=style&index=0&id=2bdd8cf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports